var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.997 13.1743C3.684 13.1743 0 13.8543 0 16.5743C0 19.2953 3.661 19.9993 7.997 19.9993C12.31 19.9993 15.994 19.3203 15.994 16.5993C15.994 13.8783 12.334 13.1743 7.997 13.1743",
    fill: "#E9A5F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M7.99708 10.5835C10.9351 10.5835 13.2891 8.22851 13.2891 5.29151C13.2891 2.35451 10.9351 -0.000488281 7.99708 -0.000488281C5.06008 -0.000488281 2.70508 2.35451 2.70508 5.29151C2.70508 8.22851 5.06008 10.5835 7.99708 10.5835",
    fill: "#E9A5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.8e46bc32f2695147f1832e6119a6e94a.svg";
export { ForwardRef as ReactComponent };